module.exports = __webpack_public_path__ + "static/media/activityIntro2.c7394d8d.png";